import { log } from 'console';
import React, { ChangeEvent, useEffect } from 'react';
import { useController, useFormContext } from 'react-hook-form';

import styles from './FormCheckbox.module.css';
import FormInput from '../formInput/FormInput';

interface FormNewCheckboxProps {
  id: string;
  label: string;
  value: any;
  required?: boolean;
  textInput?: {
    id: string;
    placeholder?: string;
    label?: string;
  };
}

const FormNewCheckbox: React.FC<FormNewCheckboxProps> = ({
  id,
  label,
  value,
  required = false,
  textInput,
}) => {
  const {
    field: { value: selectedValue, onChange },
    formState: {},
  } = useController({
    name: id,
    defaultValue: '',
    rules: { required },
  });

  const isChecked = selectedValue === value;

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      onChange(value);
    } else {
      onChange('');
    }
  };

  const { setValue } = useFormContext();

  useEffect(() => {
    if (!isChecked && textInput?.id) {
      setValue(textInput?.id, '');
    }
  }, [isChecked]);

  return (
    <div className={styles.checkboxItem}>
      <input
        id={`${id}-${value}`}
        type="checkbox"
        value={value}
        checked={isChecked}
        onChange={handleChange}
      />

      {textInput?.id ? (
        <FormInput {...textInput} isDisabled={!isChecked} required={isChecked} />
      ) : (
        <label htmlFor={`${id}-${value}`}>{label}</label>
      )}
    </div>
  );
};

export default FormNewCheckbox;
